import { render, staticRenderFns } from "./TablePaginationV2.vue?vue&type=template&id=918a7ab8&scoped=true&"
import script from "./TablePaginationV2.vue?vue&type=script&lang=js&"
export * from "./TablePaginationV2.vue?vue&type=script&lang=js&"
import style0 from "./TablePaginationV2.vue?vue&type=style&index=0&id=918a7ab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918a7ab8",
  null
  
)

export default component.exports